// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notifier[data-v-0ce3e9ec]{margin:0;padding:0;font-size:12px;font-weight:400;line-height:18px;display:flex;align-items:center;justify-content:center;gap:8px;cursor:pointer}@media(min-width:550px){.notifier[data-v-0ce3e9ec]{font-size:16px;line-height:19px}}.notifier button[data-v-0ce3e9ec]{height:40px;width:40px;border:0;border-radius:6px;flex-shrink:0;cursor:pointer}.notifier__text[data-v-0ce3e9ec]{display:flex;flex-direction:column;color:#c6c8cd}", ""]);
// Exports
module.exports = exports;
